module.exports = __webpack_public_path__ + "media/assets/ThreeDotsMenu-7aefbc47edb1c7ad78088305f351b7df.svg";